module.exports = __webpack_public_path__ + "static/mug-306490264616e63dc413012451443f0e.png";